import PropTypes from 'prop-types'
import { CloseIcon } from '../../assets/svgs/icons'
import { ModalComponent } from '../ModalComponent'
import styles from './styles.module.css'
import { t } from 'i18next'

export const ArtStatusErrorPopUp = ({
  isOpen,
  onClose,
  onRestart,
  onDiscard,
}) => {
  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      className={styles.modalContainer}
    >
      <div className={styles.content}>
        {onClose && (
          <div className={styles.header}>
            <button
              type="button"
              onClick={onClose}
              className={styles.closeButton}
              aria-label={t('pop_up_art_error.close_button') || 'Fechar'}
            >
              <CloseIcon color="#000" size="28px" />
            </button>
          </div>
        )}
        <h2 className={styles.title}>{t('pop_up_art_error.title') || 'Tivemos um problema técnico.'}</h2>
        <p className={styles.message}>
          {t('pop_up_art_error.description') || 'Sua arte não pôde ser finalizada e nenhuma geração foi descontada do seu plano.'}
        </p>
        <div className={styles.buttonsContainer}>
          <button
            type="button"
            className={styles.primaryButton}
            onClick={onRestart}
          >
            {t('pop_up_art_error.button1') || 'Recomeçar geração'}
          </button>
          {onDiscard && (
            <button
              type="button"
              className={styles.discardButton}
              onClick={onDiscard}
            >
              {t('pop_up_art_error.button2') || 'Descartar'}
            </button>
          )}
        </div>
      </div>
    </ModalComponent>
  )
}

ArtStatusErrorPopUp.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onRestart: PropTypes.func,
  onDiscard: PropTypes.func,
}

export default ArtStatusErrorPopUp
